import { useEffect, useState } from "react";

/** Seconds left until `until` (epoch ms), re-rendering once a second. 0 when there is no deadline or it passed. */
export function useSecondsUntil(until: number | null | undefined): number {
	const [, tick] = useState(0);
	useEffect(() => {
		if (!until || until <= Date.now()) return;
		const t = setInterval(() => {
			tick(n => n + 1);
			if (Date.now() >= until) clearInterval(t);
		}, 1000);
		return () => clearInterval(t);
	}, [until]);
	return until ? Math.max(0, Math.ceil((until - Date.now()) / 1000)) : 0;
}

/** Turns a server-provided "retry after N seconds" into a stable deadline (recomputed only when N or `key` change). */
export function useDeadline(seconds: number | null | undefined, key?: unknown): number | null {
	const [until, setUntil] = useState<number | null>(() => (seconds ? Date.now() + seconds * 1000 : null));
	useEffect(() => {
		setUntil(seconds ? Date.now() + seconds * 1000 : null);
	}, [seconds, key]);
	return until;
}

export const mmss = (s: number) => `${Math.floor(s / 60)}:${String(Math.max(0, Math.floor(s % 60))).padStart(2, "0")}`;
